module.exports = __webpack_public_path__ + "media/react/app_submitter/components/PhotoReader/assets/folder-fdf9ee730d954f248b44766045953062.png";